import { CHAT_TAG, LIST_QUERY_CACHE_TTL_SECONDS } from '../constants';
import { api } from '../core';
import type { GetChatResponse } from './getChat';

/**
 * Same `/chat` endpoint as `getChat`, but returns only `matter` and doesn't write the chat to the
 * store. Used by the sidebar to link recent chats to their case.
 */
export interface GetChatMatterRequest {
  chatId: string;
}

export type GetChatMatterResponse = GetChatResponse['matter'];

const getChatMatterApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getChatMatter: builder.query<GetChatMatterResponse, GetChatMatterRequest>({
      query: ({ chatId }) => ({
        url: '/chat',
        method: 'GET',
        params: { chat_id: chatId },
      }),
      transformResponse: (response: GetChatResponse) => response.matter,
      providesTags: (_result, _error, arg) => [{ type: CHAT_TAG, id: `matter-${arg.chatId}` }],
      keepUnusedDataFor: LIST_QUERY_CACHE_TTL_SECONDS,
    }),
  }),
});

export const { useGetChatMatterQuery } = getChatMatterApi;
